<template>
  <v-app id="inspire">
    <v-content>
      <v-container v-if="!authenticated" class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card elevation="0" :loading="isFetching">
            <v-card class="elevation-0" v-if="!isVisibleSuccessMessage && !isFetching">
              <v-toolbar :color="$vuetify.theme.dark ? 'light' : 'white'" flat>
                <v-toolbar-title>{{ $t("form.login.forgot") }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-form ref="passwordResetForm">
                  <v-text-field
                      outlined
                      autocomplete="username"
                      v-model="email"
                      :label="$t('form.login.email')"
                      id="email"
                      append-icon="fa-at"
                      required
                      @keyup.enter="submit"
                  ></v-text-field>
                  <v-text-field
                      outlined
                      autocomplete="username"
                      v-model="password"
                      :label="$t('form.login.password')"
                      id="password"
                      append-icon="fa-key"
                      :rules="[
                        (v) => !!v || $t('form.validationErrors.field_is_required'),
                      ]"
                      type="password"
                      required
                      @keyup.enter="submit"
                  ></v-text-field>
                  <v-text-field
                      outlined
                      autocomplete="username"
                      v-model="password_confirmation"
                      :label="$t('form.login.password_confirmation')"
                      id="password_confirmation"
                      :rules="[
                        (v) => !!v || $t('form.validationErrors.field_is_required'),
                        (v) => password_confirmation===password || $t('form.validationErrors.password_confirmation_doesnt_match'),
                      ]"
                      append-icon="fa-key"
                      type="password"
                      required
                      @keyup.enter="submit"
                  ></v-text-field>
                  <v-alert v-if="errorMessage != ''" type="error">
                    {{ errorMessage }}
                  </v-alert>
                </v-form>
                <v-divider class="mt-4 "></v-divider>
              </v-card-text>
              <v-card-actions>
                <div class="ml-2 flex-grow-1"></div>
                <v-btn
                    :disabled="isSendingRecoveryMail"
                    :loading="isSendingRecoveryMail"
                    elevation="0"
                    class="mr-2 mb-2"
                    min-width="100"
                    color="primary"
                    @click="submit"
                    @keyup.enter="submit"
                >
                  {{ $t("form.login.reset_password") }}
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card class="elevation-0" v-if="isVisibleSuccessMessage && !isFetching">
              <v-card-text>
                <h3 class="text-success py-5 pointer" @click="$router.push({ name: 'login'})">{{ $t("form.login.recovery_mail_is_sent") }}</h3>
              </v-card-text>
            </v-card>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapFields } from "vuex-map-fields";
import { mapState } from "vuex";

export default {
  data: () => ({
    isVisibleSuccessMessage:false,
    email:null,
    password_confirmation:null,
    password:null,
    errorMessage:''
  }),
  validations: {
    email: { required, email },
  },

  computed: {
    ...mapFields("site", ['isFetching']),
    ...mapFields("auth", [
      "isSendingRecoveryMail",
      "authenticated"
    ]),
  },
  mounted() {
    this.email = this.$route.params.email;
    this.$store.dispatch("site/getLangByEmail", this.email).then((lang)=>{
      this.$i18n.locale = lang;
      this.$store.dispatch('site/setLangAndCurrency', lang).then(()=>{
        this.$i18n.locale = lang;
        this.i18n.locale = lang;
      })
    })
  },
  methods: {
    submit(){
      this.errorMessage='';
      if (!this.$refs.passwordResetForm.validate()) return;

      this.$store.dispatch("auth/passwordReset", {
        email: this.email,
        password_confirmation: this.password_confirmation,
        password: this.password,
        token: this.$route.params.token,

      }).then((res) => {
        if (res && res.status === "success") {
          this.$router.push({ name: "home" });
        }
      });
    }
  },
};
</script>
